import request from '@/utils/request'

/**
 * 获取直播详情
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getLiveDetailApi(data) {
	return request({
		url: 'share/live/detail',
		method: 'post',
		data: data,
	})
}
